import React from 'react';

interface OrderStatusBadgeProps {
  status: string | undefined | null;
  variant?: 'chip' | 'badge';
  className?: string;
  style?: React.CSSProperties;
}

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({
  status,
  variant = 'chip',
  className = '',
  style,
}) => {
  const rawStatus = (status || 'pending').toLowerCase();
  const statusClass = rawStatus.replace(/_/g, '-');
  const statusLabel = (status || 'Pending').replace(/_/g, ' ');

  if (variant === 'badge') {
    return (
      <span
        className={`status-badge ${statusClass} ${className}`.trim()}
        style={style}
      >
        {statusLabel}
      </span>
    );
  }

  return (
    <span
      className={`om-status-chip om-status-${statusClass} ${className}`.trim()}
      style={style}
    >
      {statusLabel}
    </span>
  );
};

export default OrderStatusBadge;
